export function CopyToClipboard(text: string) {
    if (text && text != null && text.trim() != "") {
        window.prompt("Copia negli appunti: Ctrl+C, Invio", text);
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/functions/copy-to-clipboard.ts